const autoNgTemplateLoaderTemplate1 = require('./wizard-endpoint-type.html');

import angular from 'angular';

angular.module('shbdeployer.app').component('wizardEndpointType', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    endpointTitle: '@',
    description: '@',
    icon: '@',
    active: '<',
  },
});
